import React, { useEffect } from "react";
import styles from "./privacypolicy.module.scss";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
const PRIVACY_SECTIONS = [
  {
    title: "1. Company Information",
    content: [
      "Company Name: Penspace Enterprises Pvt. Ltd.",
      "Registered Address:",
      "Building No./Flat No.: 01",
      "Name of Premises/Building: Naik Ramrao Tulshiram",
      "Road/Street: Tq. Degloor",
      "Locality/Sub Locality: At Post Degloor",
      "City/Town/Village: Deglur",
      "District: Nanded",
      "State: Maharashtra",
      "PIN Code: 431717",
      "India",
      "Contact Email: info@penspace.com",
      "Phone: +91 9003673683",
    ],
    list: null,
  },
  {
    title: "2. Information We Collect",
    content: "We collect information to provide, improve, and secure the Penspace platform.",
    list: null,
  },
  {
    title: "2.1 Information You Provide Directly",
    content: "When you create an account or use the service, we may collect:",
    list: [
      "Name",
      "Email address",
      "Account login credentials",
      "Profile information",
      "Preferences related to books and learning",
      "Feedback and support messages",
      "Any information voluntarily provided to us",
    ],
  },
  {
    title: "2.2 Authentication Information",
    content: [
      "Penspace allows users to log in using:",
    ],
    list: [
      "Google Login",
      "Apple Login",
      "Email and Password",
    ],
  },
  {
    title: "2.2 Authentication Information (continued)",
    content:
      "When you log in using Google or Apple, we may receive your name, email address, and a unique authentication identifier. We do not receive or store your third-party account passwords.",
    list: null,
  },
  {
    title: "2.3 Usage and Interaction Data",
    content: "We collect data related to how you interact with the platform, including:",
    list: [
      "Books viewed",
      "Summaries accessed",
      "Reading progress",
      "Time spent within the application",
      "App features used",
      "Device interaction events",
    ],
  },
  {
    title: "2.4 Analytics Data",
    content: "Penspace uses analytics tools including Firebase Analytics and Google Analytics. These services may collect:",
    list: ["Device information", "App usage data", "Interaction metrics", "Crash diagnostics"],
  },
  {
    title: "2.4 Analytics Data (continued)",
    content: "This information is used solely for improving our services and user experience.",
    list: null,
  },
  {
    title: "2.5 Device and Technical Information",
    content: "We may automatically collect:",
    list: [
      "Device type",
      "Operating system",
      "App version",
      "IP address",
      "Device identifiers",
      "Language preferences",
      "Time zone settings",
    ],
  },
  {
    title: "2.6 Payment Information",
    content: [
      "Subscriptions are processed through Apple App Store In-App Purchases and Google Play Store Subscriptions. Payments are handled entirely by Apple and Google.",
      "Penspace does not collect or store credit card or banking information.",
      "We may receive limited information such as subscription status, transaction confirmation, and subscription renewal dates.",
    ],
    list: null,
  },
  {
    title: "2.7 Notifications and Communication",
    content: "If you enable notifications, we may send:",
    list: [
      "Push notifications",
      "Product updates",
      "Feature announcements",
      "Promotional messages",
      "Newsletters",
    ],
  },
  {
    title: "2.7 Notifications and Communication (continued)",
    content:
      "You can opt out of communications at any time through your device settings or email unsubscribe links.",
    list: null,
  },
  {
    title: "3. How We Use Your Information",
    content: "Penspace uses collected data for the following purposes:",
    list: [
      "To create and manage user accounts",
      "To provide access to book summaries and learning features",
      "To personalize user experiences",
      "To improve application functionality",
      "To analyze usage patterns",
      "To communicate service updates",
      "To provide customer support",
      "To maintain platform security",
      "To comply with legal obligations",
    ],
  },
  {
    title: "4. OCR Processing",
    content: [
      "Penspace may provide features that allow users to capture text using their device camera. All Optical Character Recognition (OCR) processing occurs locally on the user's device.",
      "Images captured for OCR are not transmitted to Penspace servers unless explicitly saved by the user.",
      "Users are responsible for ensuring that any content they scan complies with applicable copyright laws.",
    ],
    list: null,
  },
  {
    title: "5. Community Features",
    content: [
      "Penspace may introduce community features allowing users to share posts or content. Information shared publicly may be visible to other users.",
      "Users are responsible for the information they choose to make public.",
      "Penspace reserves the right to moderate community content to maintain platform integrity.",
    ],
    list: null,
  },
  {
    title: "6. Data Storage and Hosting",
    content:
      "Penspace hosts its infrastructure on Amazon Web Services (AWS) servers located in India. All user data is stored within Indian data centers. We implement appropriate security measures to protect user data.",
    list: null,
  },
  {
    title: "7. Data Retention",
    content: [
      "Penspace retains personal information only for as long as necessary to provide services.",
      "If a user deletes their account:",
    ],
    list: [
      "Personal data will be permanently removed from our systems",
      "Data deletion is processed immediately or within a reasonable technical timeframe",
    ],
  },
  {
    title: "7. Data Retention (continued)",
    content: "Some minimal records may be retained if required for legal or regulatory purposes.",
    list: null,
  },
  {
    title: "8. Data Security",
    content: [
      "Penspace implements reasonable security practices including:",
    ],
    list: [
      "Encryption of data transmission",
      "Secure infrastructure hosting",
      "Access control mechanisms",
      "Regular monitoring of system vulnerabilities",
    ],
  },
  {
    title: "8. Data Security (continued)",
    content:
      "However, no method of electronic transmission or storage is completely secure.",
    list: null,
  },
  {
    title: "9. Sharing of Information",
    content:
      "Penspace does not sell personal data. We may share information only with trusted service providers necessary to operate the platform, including:",
    list: [
      "Cloud hosting providers (AWS)",
      "Analytics providers (Firebase, Google Analytics)",
      "App distribution platforms (Apple App Store, Google Play)",
    ],
  },
  {
    title: "9. Sharing of Information (continued)",
    content: "These providers are contractually required to protect your data.",
    list: null,
  },
  {
    title: "10. International Users",
    content: [
      "Penspace currently operates primarily within India. However, users from other jurisdictions may access the service.",
      "By using Penspace, you consent to the processing of your information in India.",
      "Future expansion to other regions may involve additional data protection compliance.",
    ],
    list: null,
  },
  {
    title: "11. User Rights",
    content:
      "Depending on applicable laws, users may have rights including:",
    list: [
      "Access to personal information",
      "Correction of inaccurate information",
      "Request for deletion of personal data",
      "Withdrawal of consent",
      "Restriction of data processing",
    ],
  },
  {
    title: "11. User Rights (Requests)",
    content: "Requests may be submitted to: info@penspace.com",
    list: null,
  },
  {
    title: "12. Children’s Privacy",
    content:
      "Penspace services are intended for individuals 18 years or older. We do not knowingly collect personal data from individuals under 18. If we become aware that data has been collected from a minor, we will delete such information promptly.",
    list: null,
  },
  {
    title: "13. Third-Party Links",
    content:
      "Penspace may include links to third-party websites or services. We are not responsible for the privacy practices of external platforms. Users should review the privacy policies of those services independently.",
    list: null,
  },
  {
    title: "14. Changes to This Privacy Policy",
    content:
      "Penspace may update this Privacy Policy periodically. Changes will be reflected by updating the Effective Date. Continued use of the service after changes constitutes acceptance of the updated policy.",
    list: null,
  },
  {
    title: "15. Contact Us",
    content: null,
    list: null,
    contact: true,
  },
];
export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = "Privacy Policy - Penspace";
    return () => {
      document.title = "Penspace";
    };
  }, []);
  const renderListItem = (item, i) => {
    if (typeof item === "string") {
      return <li key={i}>{item}</li>;
    }
    return (
      <li key={i}>
        <strong>{item.label}:</strong> {item.description}
      </li>
    );
  };
  const renderContent = (content) => {
    if (!content) return null;
    if (Array.isArray(content)) {
      return content.map((text, i) => <p key={i}>{text}</p>);
    }
    return <p>{content}</p>;
  };
  return (
    <div className={styles.wrapper}>
      <Header />
      <section className={styles.legalPage}>
        <div className={styles.container}>
          <div className={styles.legalContent}>
            <h1 className={styles.legalTitle}>Privacy Policy</h1>
            <p className={styles.legalSubtitle}>Effective Date: March 10, 2026</p>
            <p>
              Penspace Enterprises Pvt. Ltd. ("Penspace", "Company", "we", "our",
              or "us") operates the Penspace mobile application and related
              services (collectively, the "Service").
            </p>
            <p>
              This Privacy Policy explains how we collect, use, disclose, and
              safeguard your information when you use our services. It also
              describes your privacy rights and how the law protects you.
            </p>
            <p>
              By using Penspace, you agree to the practices described in this
              Privacy Policy.
            </p>
            {PRIVACY_SECTIONS.map((section, index) => (
              <div key={index} className={styles.legalSection}>
                <h2>{section.title}</h2>
                {section.contact ? (
                  <>
                    <p>
                      For questions or concerns regarding this Privacy Policy,
                      contact:
                    </p>
                    <p>
                      Penspace Enterprises Pvt. Ltd.
                      <br />
                      Email:{" "}
                      <a
                        href="mailto:info@penspace.com"
                        className={styles.legalLink}
                      >
                        info@penspace.com
                      </a>
                      <br />
                      Phone: +91 9003673683
                    </p>
                  </>
                ) : (
                  <>
                    {renderContent(section.content)}
                    {section.list && (
                      <ul>
                        {section.list.map((item, i) => renderListItem(item, i))}
                      </ul>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}











